<template>
  <ResponsiveDropdown
    :title="$t('components.buttons.link_file')"
    :items="actions"
    align="end"
    @click="$emit('goToStep', $event)"
  >
    <slot />
  </ResponsiveDropdown>
</template>

<script setup>
import { computed, inject } from "vue";
import { ResponsiveDropdown } from "@/SharedComponents/Dropdown";
import { useI18n } from "vue-i18n";

defineEmits(["goToStep"]);

const props = defineProps({
  buildingId: { type: String, required: true },
});

const { t } = useI18n();
const { hasPermission, permissions } = inject("permissions");

const actions = computed(() => {
  const actions = [];
  if (hasPermission(permissions.createDocument, props.buildingId)) {
    actions.push({
      id: "upload",
      label: t("components.passport.files.actions.upload"),
      event: "upload",
    });
  }
  actions.push({
    id: "select",
    label: t("components.passport.files.actions.select"),
    event: "select",
  });
  return actions;
});
</script>
